"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingGroupSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const SchGroupDrawableTypes_1 = require("./SchGroupDrawableTypes");
const XYPosition_1 = require("./XYPosition");
exports.DrawingGroupSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('group'),
    pos: XYPosition_1.XYPositionSchema,
    angle: zod_1.z.number().optional(),
    drawings: SchGroupDrawableTypes_1.SchGroupDrawableTypesSchema.array(),
    net: zod_1.z.string().optional(),
});
//# sourceMappingURL=DrawingGroup.js.map